export default "__VITE_ASSET__B$IUQj6o__"